import React, {useMemo} from 'react';
import { Box } from '@mui/joy';
import { KPI } from '../../../../mtska-frontend-app-component';
import List from './List';

const Default = () => {

    return useMemo(() => <>
        <Box className="mtksa-chart-wrapper">
            <KPI
                title="People"
                icon="faPerson"
                dataProviderName={'statistics/total/count/persons/person'}
            />
            <KPI
                title="Reports"
                icon="faChartSimple"
                dataProviderName={'statistics/total/count/bis/bi'}
            />
        </Box>
        <List />
    </>,[])

}

export default Default;


